import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

const permissionsSelector = (state: RootState) => state.user.loggedUser.permissions;
// transform permissions list from flat array "[1, 2, 3]" into a dictionary "{1: true, 2: true, 3: true}"
// to reduce complexity
export const permissionsDictionarySelector = createSelector([permissionsSelector], (permissions = []) =>
  permissions.reduce((acc: Record<number, boolean>, item: number) => {
    acc[item] = true;
    return acc;
  }, {})
);
